var _excluded = ["children", "className", "copyright", "elevation", "logo", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import clsx from 'clsx';
import { Container, Paper, Typography, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Root = styled(Paper, {
  name: 'MnrlFooter',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.root];
  }
})(function (_ref) {
  var theme = _ref.theme;
  return {
    borderTop: "1px solid " + theme.palette.divider,
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.sizing.footerHeight,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1)
  };
});
var Title = styled(Typography, {
  name: 'MnrlFooter',
  slot: 'Title',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.title];
  }
})(function (_ref2) {
  var theme = _ref2.theme;
  return {
    marginLeft: theme.spacing(2),
    whiteSpace: 'nowrap'
  };
});
var Inner = styled('div', {
  name: 'MnrlFooter',
  slot: 'Inner',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.inner];
  }
})(function (_ref3) {
  var theme = _ref3.theme;
  return {
    flex: '1 1 auto',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    '&& > *': {
      marginLeft: theme.spacing(2)
    }
  };
});
var Items = styled('div', {
  name: 'MnrlFooter',
  slot: 'Items',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.items];
  }
})(function (_ref4) {
  var theme = _ref4.theme;
  return {
    alignItems: 'center',
    display: 'flex',
    '&& > *': {
      marginLeft: theme.spacing(2)
    }
  };
});
export var Footer = function Footer(_ref5) {
  var children = _ref5.children,
      className = _ref5.className,
      _ref5$copyright = _ref5.copyright,
      copyright = _ref5$copyright === void 0 ? '© 2021 Broadcom. All Rights Reserved.' : _ref5$copyright,
      _ref5$elevation = _ref5.elevation,
      elevation = _ref5$elevation === void 0 ? 1 : _ref5$elevation,
      logo = _ref5.logo,
      title = _ref5.title,
      restProps = _objectWithoutPropertiesLoose(_ref5, _excluded);

  return /*#__PURE__*/_jsx(Root // @ts-ignore - MUI issue with component prop
  , _extends({
    component: "footer",
    elevation: elevation,
    square: true,
    className: clsx('MnrlFooter-root', className)
  }, restProps, {
    children: /*#__PURE__*/_jsxs(Container, {
      maxWidth: false,
      sx: {
        display: 'flex',
        alignItems: 'center'
      },
      children: [logo, title && /*#__PURE__*/_jsx(Title, {
        variant: "h5" // @ts-ignore - MUI issue with component prop
        ,
        component: "span",
        className: "MnrlFooter-title",
        children: title
      }), /*#__PURE__*/_jsxs(Inner, {
        className: "MnrlFooter-inner",
        children: [copyright && /*#__PURE__*/_jsx(Typography, {
          align: "right",
          color: "text.secondary",
          variant: "caption",
          children: copyright
        }), /*#__PURE__*/_jsx(Items, {
          className: "MnrlFooter-items",
          children: children
        })]
      })]
    })
  }));
};